module.exports = __webpack_public_path__ + "img/treatment-triangle-light.7aac00aa.svg";